module.exports = __webpack_public_path__ + "static/mentorship-og-image-27db0235dba151148a352f5b078b576d.png";